export const Logo = ({ className = "w-7 h-7" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 10.5 12 3l9 7.5" />
    <path d="M5 9.4V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.4" />
    <path d="M8.5 13.5l2.2 2.2 4.3-4.3" />
  </svg>
);
